<script setup lang="ts">
interface LogoProps {
    fill: string
}

defineProps<LogoProps>()
</script>

<template>
<svg
width="176"
height="38"
viewBox="0 0 176 38"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<path
d="M20.2671 0.605469H13.6971L7.27481 9.31718H5.33788V0.605469H0V22.9812H5.33788V14.1249H7.22662L14.2725 22.9812H20.984L11.5885 11.5222L20.2671 0.605469Z"
:fill="fill"
/>
<path
d="M29.042 0.605469H23.7041V22.9812H29.042V0.605469Z"
:fill="fill"
/>
<path
d="M43.6338 0.605469H34.0608V22.9812H43.6338C50.6315 22.9812 55.2525 18.538 55.2525 11.7933C55.2525 5.04868 50.6315 0.605469 43.6338 0.605469ZM43.5223 18.0409H39.3986V5.54271H43.5223C47.6763 5.54271 49.6735 8.13333 49.6735 11.7933C49.6735 15.4081 47.6763 18.0409 43.5223 18.0409Z"
:fill="fill"
/>
<path
d="M57.6835 5.41619H68.6485L57.6685 18.794V22.9812H75.7576V18.1705H64.7625L75.7576 4.79264V0.605469H57.6835V5.41619Z"
:fill="fill"
/>
<path
d="M118.834 14.2544L108.637 0.605469H103.522V22.9812H108.863V9.33223L119.057 22.9812H124.187V0.605469H118.834V14.2544Z"
:fill="fill"
/>
<path
d="M134.546 14.0797H145.59V9.28404H134.546V5.55777H146.276V0.605469L129.208 0.750065V22.9812H146.34V18.1705H134.546V14.0797Z"
:fill="fill"
/>
<path
d="M149.316 5.56078H155.949V22.9812H161.287V5.56078H167.902V0.605469H149.316V5.56078Z"
:fill="fill"
/>
<path
d="M88.9032 3.84735e-07C86.5708 0.000596138 84.2909 0.692775 82.3519 1.98901C80.4129 3.28524 78.9018 5.1273 78.0096 7.28231C77.1175 9.43731 76.8844 11.8085 77.3398 14.096C77.7952 16.3834 78.9186 18.4845 80.5681 20.1336C82.2175 21.7826 84.319 22.9055 86.6066 23.3603C88.8942 23.8151 91.2652 23.5814 93.4199 22.6887C95.5747 21.796 97.4164 20.2844 98.7121 18.345C100.008 16.4057 100.7 14.1257 100.7 11.7933C100.7 10.2444 100.394 8.71056 99.8015 7.27953C99.2086 5.8485 98.3396 4.54828 97.2442 3.45313C96.1488 2.35798 94.8485 1.48936 93.4173 0.896864C91.9861 0.304371 90.4522 -0.000395267 88.9032 3.84735e-07ZM88.9032 18.2819C87.6199 18.2819 86.3654 17.9014 85.2984 17.1884C84.2313 16.4754 83.3996 15.462 82.9085 14.2764C82.4174 13.0908 82.2889 11.7861 82.5393 10.5275C82.7897 9.26881 83.4075 8.11266 84.3149 7.20521C85.2224 6.29777 86.3787 5.67979 87.6374 5.42943C88.896 5.17907 90.2007 5.30755 91.3863 5.79866C92.5719 6.28976 93.5854 7.12143 94.2983 8.18847C95.0113 9.25552 95.3918 10.51 95.3918 11.7933C95.3926 12.6459 95.2254 13.4903 94.8996 14.2783C94.5739 15.0662 94.0961 15.7822 93.4935 16.3854C92.8909 16.9885 92.1754 17.467 91.3878 17.7935C90.6002 18.1199 89.7558 18.288 88.9032 18.288"
:fill="fill"
/>
<path
d="M88.9033 25.385C85.7755 25.385 82.7757 26.6275 80.5641 28.8392C78.3524 31.0509 77.1099 34.0506 77.1099 37.1783H82.4177C82.399 36.3147 82.553 35.456 82.8707 34.6527C83.1883 33.8493 83.6632 33.1175 84.2674 32.5001C84.8716 31.8827 85.5933 31.3922 86.3896 31.0573C87.1859 30.7225 88.0409 30.55 88.9048 30.55C89.7686 30.55 90.624 30.7225 91.4203 31.0573C92.2166 31.3922 92.9379 31.8827 93.5422 32.5001C94.1464 33.1175 94.6212 33.8493 94.9389 34.6527C95.2565 35.456 95.4105 36.3147 95.3919 37.1783H100.7C100.7 35.6294 100.394 34.0956 99.8016 32.6645C99.2087 31.2335 98.3398 29.9333 97.2443 28.8381C96.1489 27.743 94.8486 26.8743 93.4174 26.2819C91.9862 25.6894 90.4523 25.3846 88.9033 25.385Z"
:fill="fill"
/>
<path
d="M175.999 3.0816C176.01 3.58461 175.871 4.07942 175.599 4.50281C175.327 4.9262 174.935 5.25895 174.474 5.45854C174.012 5.65814 173.501 5.71551 173.006 5.62335C172.512 5.5312 172.056 5.29368 171.697 4.94115C171.338 4.58861 171.092 4.13707 170.991 3.6442C170.89 3.15134 170.938 2.63952 171.129 2.17414C171.32 1.70876 171.646 1.31095 172.064 1.03153C172.483 0.75211 172.975 0.603756 173.478 0.605438C174.14 0.602202 174.776 0.860621 175.249 1.3244C175.721 1.78818 175.991 2.41976 175.999 3.0816ZM175.397 3.0816C175.396 2.70064 175.282 2.32859 175.069 2.01258C174.856 1.69658 174.554 1.45081 174.202 1.3064C173.849 1.162 173.462 1.12545 173.089 1.20138C172.715 1.27731 172.373 1.46233 172.105 1.73297C171.836 2.00362 171.655 2.34773 171.582 2.72175C171.51 3.09576 171.55 3.48284 171.698 3.834C171.845 4.18516 172.094 4.4846 172.412 4.69439C172.73 4.90418 173.103 5.01488 173.484 5.0125C173.737 5.01332 173.988 4.9638 174.221 4.86683C174.455 4.76986 174.667 4.62737 174.845 4.44767C175.023 4.26796 175.164 4.05463 175.258 3.8201C175.353 3.58557 175.4 3.33453 175.397 3.0816ZM174.554 2.65684C174.554 3.03339 174.285 3.30149 173.818 3.35571L174.572 4.22327H173.969L173.273 3.36174H173.047V4.22327H172.556V1.92183H173.62C174.222 1.92183 174.541 2.22307 174.541 2.65684M173.035 2.35561V2.95808H173.602C173.861 2.95808 174.026 2.85566 174.026 2.65684C174.026 2.45803 173.861 2.35561 173.602 2.35561H173.035Z"
:fill="fill"
/>
</svg>
</template>
